import { useState, useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { hasSession, currentUser, logout, onAuthChange } from '@/lib/session';

// 24小时（毫秒）
const SESSION_TTL_MS = 24 * 60 * 60 * 1000;
// localStorage key，记录前端最后一次登录成功的时间戳
const LOGIN_TIME_KEY = 'jinan_user_login_at';

export function markUserLoginTime() {
  try {
    localStorage.setItem(LOGIN_TIME_KEY, String(Date.now()));
  } catch {
    // ignore
  }
}

function isSessionExpiredLocally(): boolean {
  try {
    const raw = localStorage.getItem(LOGIN_TIME_KEY);
    if (!raw) return false; // 无记录时不强制踢出，由登录态自身判断
    const loginAt = Number(raw);
    return Date.now() - loginAt > SESSION_TTL_MS;
  } catch {
    return false;
  }
}

export default function AuthGuard() {
  const [loading, setLoading] = useState(true);
  const [authed, setAuthed] = useState(false);

  useEffect(() => {
    let mounted = true;

    const boot = async () => {
      // 先做本地 24 小时检查
      if (isSessionExpiredLocally()) {
        await logout();
        if (mounted) {
          setAuthed(false);
          setLoading(false);
        }
        return;
      }

      if (!hasSession()) {
        if (mounted) {
          setAuthed(false);
          setLoading(false);
        }
        return;
      }

      const user = await currentUser();
      if (!mounted) return;
      setAuthed(!!user);
      setLoading(false);
    };

    boot();

    const unsubscribe = onAuthChange((user) => {
      if (!mounted) return;
      setAuthed(!!user);
      setLoading(false);
    });

    return () => {
      mounted = false;
      unsubscribe();
    };
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-brown-50">
        <span className="w-8 h-8 border-2 border-gold-500/30 border-t-gold-500 rounded-full animate-spin"></span>
      </div>
    );
  }

  if (!authed) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}